import { render, staticRenderFns } from "./CardInsuranceCoverage.vue?vue&type=template&id=63545d7c&"
import script from "./CardInsuranceCoverage.vue?vue&type=script&lang=js&"
export * from "./CardInsuranceCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports